export default __webpack_public_path__ + "static/accelerate-ai-28c3787d03ab90bc46f0d99f956b059588eca2cce40f571f5631b0fe68b66236.png";